const projects = [
  {
    name: "Crwn Clothing",
    image: "../../assets/images/img-1.jpg",
    url: "https://lukas-crwn-clothing.netlify.app/",
    type: "react",
    id: 1,
  },
  {
    name: "Monster Rolodexs",
    image: "../../assets/images/img-2.jpg",
    url: "https://lukas-monsters-rolodex.netlify.app/",
    type: "react",
    id: 2,
  },
  {
    name: "Todo App",
    image: "../../assets/images/img-3.jpg",
    url: "https://lukas-todo-app.netlify.app/",
    type: "react",
    id: 3,
  },
  {
    name: "Currency Converter App",
    image: "../../assets/images/img-4.jpg",
    url: "https://lukas-currency-converter.netlify.app/",
    type: "react",
    id: 4,
  },
  {
    name: "Pong",
    image: "../../assets/images/img-5.jpg",
    url: "https://lukas-pong.netlify.app/",
    type: "js",
    id: 5,
  },
  {
    name: "Paint Clone",
    image: "../../assets/images/img-6.jpg",
    url: "https://lukas-paint-clone.netlify.app/",
    type: "js",
    id: 6,
  },
  {
    name: "Calculator",
    image: "../../assets/images/img-7.jpg",
    url: "https://lukas-calculator.netlify.app/",
    type: "js",
    id: 7,
  },
  {
    name: "Math Sprint Game",
    image: "../../assets/images/img-8.jpg",
    url: "https://lukas-math-sprint-game.netlify.app/",
    type: "js",
    id: 8,
  },
  {
    name: "Drag And Drop",
    image: "../../assets/images/img-9.jpg",
    url: "https://lukas-drag-and-drop.netlify.app/",
    type: "js",
    id: 9,
  },
  {
    name: "Splash page",
    image: "../../assets/images/img-10.jpg",
    url: "https://lukas-splash-page.netlify.app/",
    type: "js",
    id: 10,
  },
  {
    name: "NASA API Pictures",
    image: "../../assets/images/img-11.jpg",
    url: "https://lukas-nasa-api-pictures.netlify.app/",
    type: "js",
    id: 11,
  },
  {
    name: "Spock Rock Game",
    image: "../../assets/images/img-12.jpg",
    url: "https://lukas-spock-rock-game.netlify.app/",
    type: "js",
    id: 12,
  },
  {
    name: "Video Player",
    image: "../../assets/images/img-13.jpg",
    url: "https://lukas-video-player.netlify.app/",
    type: "js",
    id: 13,
  },
  {
    name: "Music Player",
    image: "../../assets/images/img-14.jpg",
    url: "https://lukas-music-player.netlify.app/",
    type: "js",
    id: 14,
  },
  {
    name: "Form Validation",
    image: "../../assets/images/img-15.jpg",
    url: "https://lukas-form-validation.netlify.app/",
    type: "js",
    id: 15,
  },
  {
    name: "Book keeper",
    image: "../../assets/images/img-16.jpg",
    url: "https://lukas-book-keeper.netlify.app/",
    type: "js",
    id: 16,
  },
  {
    name: "Costume Countdown",
    image: "../../assets/images/img-17.jpg",
    url: "https://lukas-costume-countdown.netlify.app/",
    type: "js",
    id: 17,
  },
  {
    name: "Picture In Picture",
    image: "../../assets/images/img-18.jpg",
    url: "https://lukas-picture-in-picture.netlify.app/",
    type: "js",
    id: 18,
  },
  {
    name: "Infinite Scroll",
    image: "../../assets/images/img-19.jpg",
    url: "https://lukas-infinite-scroll.netlify.app/",
    type: "js",
    id: 19,
  },
  {
    name: "Joke Teller",
    image: "../../assets/images/img-20.jpg",
    url: "https://lukas-joke-teller.netlify.app/",
    type: "js",
    id: 20,
  },
  {
    name: "Animated Navigation",
    image: "../../assets/images/img-21.jpg",
    url: "https://lukas-animated-navigation.netlify.app/",
    type: "js",
    id: 21,
  },
  {
    name: "Animated Template",
    image: "../../assets/images/img-22.jpg",
    url: "https://lukas-animated-template.netlify.app/",
    type: "js",
    id: 22,
  },
  {
    name: "Light And Dark Mode",
    image: "../../assets/images/img-23.jpg",
    url: "https://lukas-light-dark-mode.netlify.app/",
    type: "js",
    id: 23,
  },
  {
    name: "Quote Generator",
    image: "../../assets/images/img-24.jpg",
    url: "https://lukas-quote-generator.netlify.app/",
    type: "js",
    id: 24,
  },
  {
    name: "Omnifood Template",
    image: "../../assets/images/img-25.jpg",
    url: "https://lukas-omnifood-site.netlify.app/",
    type: "html/css",
    id: 25,
  },
];

export default projects;
